module.exports = __webpack_public_path__ + "img/SuperOK_Spotify_2021.93fab724.jpeg";